import { Stack, styled } from '@mui/material';

const FieldFooter = styled(Stack)`
  min-height: 58px;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;

  gap: 0.5rem;
`;

export default FieldFooter;
